/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rd_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`By default the first occurrence of each line is kept and later duplicates are removed. Enable 'Sort alphabetically' to reorder the unique lines instead.`)
};

const es_rd_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De forma predeterminada se mantiene la primera ocurrencia de cada línea y se eliminan los duplicados posteriores. Activa 'Ordenar alfabéticamente' para reordenar las líneas únicas en su lugar.`)
};

const de_rd_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standardmäßig wird das erste Vorkommen jeder Zeile behalten und spätere Duplikate werden entfernt. Aktivieren Sie 'Alphabetisch sortieren', um die eindeutigen Zeilen stattdessen neu zu ordnen.`)
};

const nl_rd_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standaard wordt het eerste voorkomen van elke regel behouden en worden latere duplicaten verwijderd. Schakel "Alfabetisch sorteren" in om de unieke regels opnieuw in te delen.`)
};

const fr_rd_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Par défaut, la première occurrence de chaque ligne est conservée et les doublons ultérieurs sont supprimés. Activez "Trier alphabétiquement" pour réorganiser les lignes uniques à la place.`)
};

const it_rd_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per impostazione predefinita, la prima occorrenza di ogni riga viene mantenuta e i duplicati successivi vengono rimossi. Abilita "Ordina alfabeticamente" per riordinare le righe univoche invece.`)
};

const pt_br2_rd_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por padrão, a primeira ocorrência de cada linha é mantida e as duplicatas posteriores são removidas. Ative 'Classificar alfabeticamente' para reorganizar as linhas únicas em seu lugar.`)
};

const pt_rd_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por padrão, a primeira ocorrência de cada linha é mantida e as duplicatas posteriores são removidas. Ative 'Ordenar alfabeticamente' para reordenar as linhas únicas em vez disso.`)
};

const ja_rd_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デフォルトでは各行の最初の出現が保持され、以降の重複が削除されます。「アルファベット順にソート」を有効にして、代わりに一意の行を並べ替えます。`)
};

const zh_rd_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`默认情况下会保留每一行的首次出现，之后的重复项会被移除。若想重新排列唯一行的顺序，可开启“按字母顺序排序”。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rd_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rd_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rd_faq1_a", locale)
	if (locale === "en") return en_rd_faq1_a(inputs)
	if (locale === "es") return es_rd_faq1_a(inputs)
	if (locale === "de") return de_rd_faq1_a(inputs)
	if (locale === "nl") return nl_rd_faq1_a(inputs)
	if (locale === "fr") return fr_rd_faq1_a(inputs)
	if (locale === "it") return it_rd_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_rd_faq1_a(inputs)
	if (locale === "pt") return pt_rd_faq1_a(inputs)
	if (locale === "ja") return ja_rd_faq1_a(inputs)
	return zh_rd_faq1_a(inputs)
};